import Swiper from 'swiper/bundle'
import GLightbox from 'glightbox'

export default {
  init() {
    const galleryThumbs = new Swiper('.gallery-thumbs', {
      spaceBetween: 8,
      slidesPerView: 10,
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    })
    new Swiper('.gallery-top', {
      spaceBetween: 0,
      autoHeight: true,
      effect: 'fade',
      thumbs: {
        swiper: galleryThumbs,
      },
    })

    GLightbox({
      touchNavigation: true,
      loop: true,
      autoplayVideos: true,
    })
  },
  finalize() {},
}
